import React from 'react'
import { Form, Input, InputNumber, Popconfirm, Space, Button as AntdButton } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/components'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'shared/components/modal'
import { ExpenseItemDto } from 'api-client'
import { DailySummaryStore } from 'store/daily-summary.store'
import { MembersStore } from 'store/members.store'
import { ReportsStore } from 'store/reports.store'

interface CloseDayModalProps {
  from: string
  to: string
  onClose: () => void
}

export const CloseDayModal = observer(({ from, to, onClose }: CloseDayModalProps) => {
  const [form] = Form.useForm()

  const closeTheDay = async () => {
    const values = await form.validateFields()
    const items: ExpenseItemDto[] = (values.items ?? []).map((i: any) => ({
      title: i.title,
      amount: Number(i.amount) || 0,
    }))

    // 1) Сохраняем итог дня (разбивка расходов + заметки), итог считает сервер.
    await DailySummaryStore.submit(items, values.notes ?? '', from)
    // 2) Выгоняем всех мемберов из клуба.
    await MembersStore.kickMembersOff()
    // 3) Обновляем визиты и закрываем модалку.
    ReportsStore.loadVisits(from, to)
    onClose()
  }

  return (
    <Modal>
      <ModalHeader onClose={onClose}>Close the day</ModalHeader>
      <ModalBody>
        <Form form={form} layout="vertical" initialValues={{ items: [] }}>
          <div style={{ marginBottom: 8, fontWeight: 500 }}>Expenses</div>
          <Form.List name="items">
            {(fields, { add, remove }) => (
              <>
                {fields.map((field) => (
                  <Space key={field.key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                    <Form.Item
                      name={[field.name, 'title']}
                      rules={[{ required: true, message: 'Enter expense title' }]}
                    >
                      <Input placeholder="Expense title" />
                    </Form.Item>
                    <Form.Item
                      name={[field.name, 'amount']}
                      rules={[{ required: true, message: 'Enter amount' }]}
                    >
                      <InputNumber min={0} step={0.01} placeholder="Amount" />
                    </Form.Item>
                    <AntdButton type="link" danger onClick={() => remove(field.name)}>
                      Remove
                    </AntdButton>
                  </Space>
                ))}
                <AntdButton type="dashed" block onClick={() => add()}>
                  + Add expense
                </AntdButton>
              </>
            )}
          </Form.List>

          <Form.Item label="Notes" name="notes" style={{ marginTop: 16 }}>
            <TextArea rows={3} placeholder="Anything notable about today..." />
          </Form.Item>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Popconfirm
          title="Are you sure you want to close the Day??"
          onConfirm={closeTheDay}
          okText="Yes"
          cancelText="No"
        >
          <Button danger disabled={DailySummaryStore.submitEffect.isLoading}>
            Submit & close the day
          </Button>
        </Popconfirm>
        <Button onClick={onClose}>Cancel</Button>
      </ModalFooter>
    </Modal>
  )
})
